module.exports = __webpack_public_path__ + "static/fonts/fa-solid-900.f72d546.eot";